import React, {useContext, useState} from "react";
import "./ConnectionButton.css";
import {UserContext} from "../contexts/UserContext";
import wpAuth from "../services/wpAuth";
import ProfileDrawer from "./ProfileDrawer";
import PreferencesDrawer from "./PreferencesDrawer";
import Button from "./Button";
import Avatar from "./Avatar";

interface ConnectionButtonProps {

}

const ConnectionButton : React.FC<ConnectionButtonProps> = () => {
    const { currentUser } = useContext(UserContext);
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [isPreferencesOpen, setIsPreferencesOpen] = useState(false);
    const authUrl : string = wpAuth.authorizationUrl;


    if(!currentUser) {
        return <div className={"ConnectionButton"}><a href={authUrl}>Se connecter</a></div>;
    }

    return (
        <div className={"ConnectionButton connected"}>
            <Button variant="secondary" size="medium" onClick={() => setIsProfileOpen(true)}>
                <Avatar 
                    url={currentUser.avatar_urls["24"]} 
                    alt={currentUser.name} 
                    size="medium"
                />
                <span className={"displayName"}>{currentUser.name}</span>
            </Button>
            <ProfileDrawer 
                isOpen={isProfileOpen} 
                onClose={() => setIsProfileOpen(false)}
                onOpenPreferences={() => setIsPreferencesOpen(true)}
            />
            <PreferencesDrawer
                isOpen={isPreferencesOpen}
                onClose={() => setIsPreferencesOpen(false)}
            />
        </div>
    );
}

export default ConnectionButton;